import React from "react";
import "../styles/transaction.css";
import my_profile123 from "../images/my_profile/personel_details.svg";
import pen from "../images/my_profile/pen.svg";
import SelectDropDown from "./SelectDropDown";
import calendar_month from "../images/my_profile/calendar_month.svg";
import DatePickerInput from "./DatePickerInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../styles/profile.css";

const PersonelDetailEdit = () => {
  const formik = useFormik({
    initialValues: {
      fullName: "",
      dateOfBirth: "",
      email: "",
      emailBelongsTo: "",
      mobileNumber: "",
      mobileBelongsTo: "",
      gender: "",
      maritalStatus: "",
      parentName: "",
      occupation: "",
      pancard: "",
      aadharNumber: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Full Name is required"),
      dateOfBirth: Yup.date().required("Date of Birth is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      emailBelongsTo: Yup.string().required("This field is required"),
      mobileNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Must be a valid 10-digit number")
        .required("Mobile Number is required"),
      mobileBelongsTo: Yup.string().required("This field is required"),
      gender: Yup.string().required("Gender is required"),
      maritalStatus: Yup.string().required("Marital Status is required"),
      // parentName: Yup.string().required("Father/Husband Name is required"),
      occupation: Yup.string().required("Occupation is required"),
      pancard: Yup.string()
        .matches(/^([A-Z]{5}[0-9]{4}[A-Z]{1})$/, "Invalid PAN Details")
        .required("PAN is required"),
      aadharNumber: Yup.string()
        .matches(/^[0-9]{12}$/, "Must be a valid 12-digit Aadhar number")
        .required("Aadhar Number is required"),
      address: Yup.string().required("Address is required"),
      city: Yup.string().required("City is required"),
      state: Yup.string().required("State is required"),
      country: Yup.string().required("Country is required"),
      pincode: Yup.string().required("Pincode is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Submitted", values);
    },
  });

  return (
    <div className="accordion-item">
      <h2 className="accordion-header profile_header" id="headingTwo">
        <button
          className="accordion-button collapsed px-lg-4 px-md-4 px-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#personalTwo"
          aria-expanded="false"
          aria-controls="personalTwo"
        >
          <div className="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <img
                src={my_profile123}
                alt=""
                className="personel_details_img"
              />
              <span className="personal_inner_text">Personal Details</span>
            </div>
          </div>
        </button>
      </h2>
      <div
        id="personalTwo"
        className="accordion-collapse collapse"
        aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample"
      >
        <hr className="m-0" />
        <div className="accordion-body profile_accordion_body">
          {/* Personal Details Content */}
          <div className="card redeam_bottom_card">
            <div className="row form_body justify-content-center">
              <div className="col-xl-8 col-lg-10 col-md-11 ">
                <form onSubmit={formik.handleSubmit}>
                  <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Full Name <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="fullName"
                        placeholder="Enter Full Name"
                        {...formik.getFieldProps("fullName")}
                      />
                      {formik.touched.fullName && formik.errors.fullName && (
                        <div className="text-danger">
                          {formik.errors.fullName}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Date of Birth <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <DatePickerInput
                        value={formik.values.dateOfBirth}
                        maxDate={new Date().toISOString().split("T")[0]}
                        onChange={(date) =>
                          formik.setFieldValue("dateOfBirth", date)
                        }
                      />
                      {formik.touched.dateOfBirth &&
                        formik.errors.dateOfBirth && (
                          <div className="text-danger">
                            {formik.errors.dateOfBirth}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Email <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="anandr@gmail.com"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "email",
                            e.target.value.toLowerCase()
                          )
                        }
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Email Belongs to <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <SelectDropDown
                        name="idType"
                        id=""
                        value=""
                        changeFunction=""
                        options=""
                        {...formik.getFieldProps("emailBelongsTo")}
                      />
                      {formik.touched.emailBelongsTo &&
                        formik.errors.emailBelongsTo && (
                          <div className="text-danger">
                            {formik.errors.emailBelongsTo}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Mobile Number <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="mobileNumber"
                        placeholder="Mobile Number"
                        {...formik.getFieldProps("mobileNumber")}
                      />
                      {formik.touched.mobileNumber &&
                        formik.errors.mobileNumber && (
                          <div className="text-danger">
                            {formik.errors.mobileNumber}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Mobile Number Belongs to{" "}
                        <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <SelectDropDown
                        name="idType"
                        id=""
                        value=""
                        changeFunction=""
                        options=""
                        {...formik.getFieldProps("mobileBelongsTo")}
                      />
                      {formik.touched.mobileBelongsTo &&
                        formik.errors.mobileBelongsTo && (
                          <div className="text-danger">
                            {formik.errors.mobileBelongsTo}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Gender <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <div class="d-flex align-items-center gap-2 flex-wrap">
                        <div className="form-check form-check-inline ">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="male"
                            value="male"
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="male"
                          >
                            Male
                          </label>
                        </div>
                        <div className="form-check form-check-inline ">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="female"
                            value="female"
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="female"
                          >
                            Female
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="otherGender"
                            value="other"
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="otherGender"
                          >
                            Other
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Marital Status <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <div class="d-flex align-items-center gap-2 flex-wrap">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="maritalStatus"
                            id="married"
                            value="married"
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="married"
                          >
                            Married
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="maritalStatus"
                            id="unmarried"
                            value="unmarried"
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="unmarried"
                          >
                            Unmarried
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="maritalStatus"
                            id="otherStatus"
                            value="other"
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="otherStatus"
                          >
                            Other
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Father/Husband Name
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="parentName"
                        placeholder="Enter Father/Husband Name"
                        value=""
                        {...formik.getFieldProps("parentName")}
                      />
                      {/* {formik.touched.parentName &&
                        formik.errors.parentName && (
                          <div className="text-danger">
                            {formik.errors.parentName}
                          </div>
                        )} */}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Occupation <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <SelectDropDown
                        name="idType"
                        id=""
                        value=""
                        changeFunction=""
                        options=""
                        {...formik.getFieldProps("occupation")}
                      />
                      {formik.touched.occupation &&
                        formik.errors.occupation && (
                          <div className="text-danger">
                            {formik.errors.occupation}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        PAN <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="pancard"
                        placeholder="Enter Pan"
                        {...formik.getFieldProps("pancard")}
                      />
                      {formik.touched.pancard && formik.errors.pancard && (
                        <div className="text-danger">
                          {formik.errors.pancard}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Aadhar Number <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="aadharNumber"
                        placeholder="Enter Aadhar Number"
                        {...formik.getFieldProps("aadharNumber")}
                      />
                      {formik.touched.aadharNumber &&
                        formik.errors.aadharNumber && (
                          <div className="text-danger">
                            {formik.errors.aadharNumber}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Address <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        placeholder="Enter Address"
                        {...formik.getFieldProps("address")}
                      />
                      {formik.touched.address && formik.errors.address && (
                        <div className="text-danger">
                          {formik.errors.address}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        Pincode <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="pincode"
                        placeholder="Enter Pincode"
                        {...formik.getFieldProps("pincode")}
                      />
                      {formik.touched.pincode && formik.errors.pincode && (
                        <div className="text-danger">
                          {formik.errors.pincode}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        City <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        placeholder="Enter City"
                        {...formik.getFieldProps("city")}
                      />
                      {formik.touched.city && formik.errors.city && (
                        <div className="text-danger">{formik.errors.city}</div>
                      )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                      <label className="form-label">
                        State <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                      <SelectDropDown
                        name="idType"
                        id=""
                        value=""
                        changeFunction=""
                        options=""
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center gap-2 mt-lg-5 mt-4">
                    <button type="submit" className="form_button next_btn">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonelDetailEdit;
